<template>
  <div class="client-executives">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-data-table
            :headers="clientExecutivesHeaders"
            :items="executives"
            :options.sync="pagination"
            :server-items-length="totals"
            :loading="isLoading"
            :multi-sort="false"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [10, 25, 50, 100],
            }"
            class="elevation-1"
            @update:page="debounceGetClientsExecutives"
            @update:items-per-page="debounceGetClientsExecutives"
            @update:sort-by="getExecutives"
            @update:sort-desc="getExecutives"
          >
            <template v-slot:footer.page-text>
              <TableFooterCurrentPage :pagination="pagination" :totals="totals" />
            </template>
            <template #item.updated_at="{ value }">
              {{ value | displayDate('YYYY/MM/DD') }}
            </template>

            <template #item.last_name="{ item }">
              <router-link
                :to="{ name: 'contact-summary', params: { id: item.id } }"
                class="table-cell-link"
              >
                {{ item.last_name }}
              </router-link>
            </template>

            <template #item.first_name="{ item }">
              <router-link
                :to="{ name: 'contact-summary', params: { id: item.id } }"
                class="table-cell-link"
              >
                {{ item.first_name }}
              </router-link>
            </template>

            <template #item.action="{ item }">
              <v-btn color="primary" icon @click="unassignExecutive(item.id)">
                <v-icon>mdi-briefcase-remove-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <ConfirmDialog ref="confirmDialog" />
  </div>
</template>

<script>
import { debounce } from 'lodash';
import eventBus from '@/eventBus';
import consts from '@/api/consts';
import contactsApi from '@/api/v1/recruiter/contacts';
import clientsApi from '@/api/v1/recruiter/clients';
import ConfirmDialog from '@/components/Common/ConfirmDialog.vue';
import TableFooterCurrentPage from '@/components/Recruiter/TableFooterCurrentPage.vue';

const clientExecutivesHeaders = consts.clients.clientExecutivesHeaders;

export default {
  components: {
    ConfirmDialog,
    TableFooterCurrentPage,
  },

  data() {
    return {
      isLoading: false,
      isDialogVisible: false,
      executives: [],
      clientExecutivesHeaders,
    };
  },

  computed: {
    pagination: {
      get() {
        return this.$store.state.clients.executives.pagination;
      },
      set(val) {
        this.$store.dispatch('setClientExecutivesPagination', val);
      },
    },

    totals() {
      return this.$store.state.clients.executives.totals;
    },
  },

  mounted() {
    this.getExecutives();
    eventBus.$on('update-client-executives', () => {
      this.getExecutives();
    });
  },

  methods: {
    debounceGetClientsExecutives: debounce(function() {
      this.getExecutives();
    }, 500),

    getExecutives() {
      this.isLoading = true;

      const params = this.$store.getters.getClientExecutivesSearchParams;
      params.client_id = this.$route.params.id;
      params.show_hidden = true;

      contactsApi
        .index(params)
        .then(resp => {
          this.dataLoaded = true;
          this.executives = resp.data.collection;
          this.$store.dispatch('setClientExecutivesTotals', resp.data.pagination.itemsLength);
        })
        .catch(err => {
          this.dataLoaded = true;
          this.$store.dispatch('showError', err.response.data.errors);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    goToExecutive(executive) {
      this.$router.push({ name: 'contact-summary', params: { id: executive.id } });
    },

    unassignExecutive(contactId) {
      this.$refs.confirmDialog
        .open({ message: 'Are you sure you want to remove executive?', confirmButtonText: 'Yes' })
        .then(confirm => {
          if (confirm) {
            this.isProcessing = true;
            clientsApi
              .removeExecutive(this.$route.params.id, { contact_id: contactId })
              .then(() => {
                this.getExecutives();
              })
              .catch(err => {
                this.$store.dispatch('showError', err.response.data.errors);
              })
              .finally(() => {
                this.isProcessing = false;
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.client-executives {
  background: inherit;
}
</style>
